export class FadeOverlay {
  readonly element: HTMLElement;
  private currentAlpha = 0;

  constructor() {
    this.element = document.createElement('div');
    this.element.className = 'fade-overlay';
    this.setAlpha(0);
  }

  async fadeTo(targetAlpha: number, durationMs: number): Promise<void> {
    const start = this.currentAlpha;
    const duration = Math.max(16, durationMs);
    const t0 = performance.now();
    return new Promise((resolve) => {
      const tick = (): void => {
        const elapsed = performance.now() - t0;
        const t = Math.min(elapsed / duration, 1);
        this.setAlpha(start + (targetAlpha - start) * t);
        if (t < 1) requestAnimationFrame(tick);
        else resolve();
      };
      requestAnimationFrame(tick);
    });
  }

  setAlpha(alpha: number): void {
    this.currentAlpha = Math.max(0, Math.min(1, alpha));
    this.element.style.opacity = String(this.currentAlpha);
  }
}
